<form #authCodeForm="ngForm">
  <app-input [type]="'text'" name="authCode" [formGroup]="authCodeForm" label="Signup Code"
    [placeholder]="'Signup code'" [(ngModel)]="this.userProfile.authCode" pattern="^[A-Za-z]{4}-[A-Za-z0-9]+$" required
    (ngModelChange)="onContinue()"></app-input>
  <app-form-navigation-buttons [form]="authCodeForm" [userProfile]="userProfile"></app-form-navigation-buttons>
</form>
